import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import CloseIcon from '../../../../static/icons/ic_close_24.svg';
import LogoPandoraIcon from '../../../../static/icons/logo/ic_logo_pandora_r.svg';
import * as Actions from '../../../actions';
import Icon from '../../../components/Icon/Icon';
import ButtonT3 from '../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../../components/lib/ButtonT3/constants';
import * as Constants from '../../../constants';
import {
  AriaAttributes,
  AriaRoles,
  messages as AriaValues,
} from '../../../constants/AccessibilityConstants';
import { messages as OnboardingMessages } from '../../../constants/Onboarding';
import QA from '../../../constants/QATags';
import { isMobileDevice } from '../../../lib/CapabilitiesUtils';
import {
  getCurrentPathnameFromState,
  getMobileLongLink,
  getRootPath,
} from '../../../lib/RouteUtils';
import { createBEM } from '../../../lib/utils/css';
import IconInteractive from '../IconInteractive/IconInteractive';

import './NavHamburger.scss';

export class NavHamburger extends React.Component {
  static propTypes = {
    links: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        label: PropTypes.node.isRequired,
        href: PropTypes.string,
        isActive: PropTypes.bool,
        isHidden: PropTypes.bool,
        type: PropTypes.string,
      }),
    ).isRequired,
    onLinkClicked: PropTypes.func.isRequired,
    closeHamburgerMenu: PropTypes.func.isRequired,
    isMobileDevice: PropTypes.bool.isRequired,
    isOnboardingPage: PropTypes.bool,
    appLink: PropTypes.string.isRequired,
    linkClicked: PropTypes.func.isRequired,
    appStoreClicked: PropTypes.func.isRequired,
  };

  onClick = (e, link) => {
    e.preventDefault();
    this.props.closeHamburgerMenu();
    this.refs.link.focus();
    this.refs.link.blur();
    if (link.url) {
      this.props.onLinkClicked(link.url);
    }
    return link.onClick && link.onClick();
  };

  renderCloseMenuButton = () => {
    return (
      <div className='NavHamburger__closeMenu'>
        <IconInteractive isDark={true} onClick={this.props.closeHamburgerMenu} glyph={CloseIcon} />
      </div>
    );
  };

  onMobileCTAButtonClick = () => {
    this.props.linkClicked('menu_app');
    this.props.appStoreClicked();
  };

  renderMobileCTAButton = () => {
    return (
      <ButtonT3
        href={this.props.appLink}
        isExternalLink={true}
        size={ButtonT3Size.LARGE}
        theme={ButtonT3Theme.WHITE}
        isPillShaped={true}
        onClick={this.onMobileCTAButtonClick}
        isFull={true}
      >
        <FormattedMessage {...OnboardingMessages.listenInTheAppText} />
      </ButtonT3>
    );
  };

  renderLogo = () => {
    const linkAriaAttributes = {
      [AriaAttributes.LABEL]: AriaValues.pandoraLogo.defaultMessage,
    };

    const iconAriaAttributes = {
      [AriaAttributes.HIDDEN]: true,
    };

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div className='NavHamburger__logo' data-qa={QA.HPI} onClick={this.props.closeHamburgerMenu}>
        <Link to={getRootPath()} className='NavHamburger__logo__link' {...linkAriaAttributes}>
          <Icon
            className='NavHamburger__logo__icon'
            glyph={LogoPandoraIcon}
            aria={iconAriaAttributes}
          />
        </Link>
      </div>
    );
  };

  renderLink = (link, i) => {
    const options = {
      active: link.isActive,
      hidden: link.isHidden,
    };

    return (
      <li className={createBEM('NavHamburger__menu__item', options)} key={i}>
        <a
          href={link.url}
          ref='link'
          className='NavHamburger__menu__item__link'
          onClick={
            link.isExternal
              ? null
              : e => {
                  this.onClick(e, link);
                }
          }
          role={AriaRoles.MENUITEM}
        >
          {link.label}
        </a>
      </li>
    );
  };

  render() {
    const burgerClasses = createBEM('NavHamburger', {
      onboarding: this.props.isOnboardingPage,
    });

    return (
      <div className={burgerClasses}>
        <div className='NavHamburger__header'>
          {this.renderCloseMenuButton()}
          {this.renderLogo()}
        </div>
        <ul className='NavHamburger__menu'>
          {this.props.links &&
            this.props.links.map((link, i) => {
              return this.renderLink(link, i);
            })}
        </ul>
        <div className='NavHamburger__mobileCTA'>
          {this.props.isMobileDevice && this.renderMobileCTAButton()}
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const currentPathname = getCurrentPathnameFromState(state);

  const appLink = getMobileLongLink(state, {
    pageUrl: currentPathname,
    feature: Constants.Urls.deepLinkParams.HAMBURGER_MENU,
  });

  return {
    isMobileDevice: isMobileDevice(state),
    appLink,
  };
}

const mapDispatchToProps = {
  closeHamburgerMenu: Actions.Overlay.closeHamburgerMenu,
  linkClicked: Actions.UseCases.linkClicked,
  appStoreClicked: Actions.Integrations.appStoreClicked,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavHamburger);
